module.exports = __webpack_public_path__ + "img/9788954620826.6351d202.jpg";